/** Policy Directus « Gestionnaire DMP » (créée avec cet identifiant par `provision-dmp-directus.mjs`). Donnera aussi accès au FIBAM (lié aux DMP). */
export const DMP_POLICY_ID = 'd2278b6b-bdc2-4dbf-b814-62b16812e140'
